import React from "react";
import {url} from "../../utils/UrlsUtil";
import "../../../style/common/components/messages/_error_message_list.scss";

interface ErrorMessageListProps{
    error_list: string[];
}

const ErrorMessageList:React.FC<ErrorMessageListProps> = (
    {
        error_list = [],
    }
) => {
  if(error_list && error_list.length != 0){
      return (
          <dl className="error-message-list">
              <dt><img src={url("/images/icon/error_icon.png")}/></dt>
              <dd>
                  {error_list.map((err, index) =>
                      <p key={"p_err_msg_" + index}
                         dangerouslySetInnerHTML={{ __html: err.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}
                      ></p>
                  )}
              </dd>
          </dl>
      );
  }else{
      return <></>;
  }
}
export default ErrorMessageList;